<ng-container *transloco="let t">
  <div class="flex items-center justify-center min-h-[calc(100vh-200px)] p-8 bg-gray-100">
    <div class="text-center max-w-md py-12 px-8 bg-white rounded-xl shadow-card">
      <div class="w-20 h-20 mx-auto mb-6 text-red-600">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-full h-full"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>

      <h1 class="text-2xl font-semibold text-gray-800 mb-4">{{ title() || t('errorsServerError') }}</h1>

      <p class="text-base text-gray-500 leading-relaxed mb-8">{{ message() || t('errorsServerErrorMessage') }}</p>

      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        @if (showRetry()) {
          <button mat-flat-button color="primary" class="min-w-[140px]" (click)="onRetry()">
            {{ retryButtonText() || t('commonTryAgain') }}
          </button>
        }
        @if (showHomeButton()) {
          <button mat-stroked-button class="min-w-[140px]" (click)="onGoHome()">
            {{ homeButtonText() || t('errorsGoToDashboard') }}
          </button>
        }
      </div>
    </div>
  </div>
</ng-container>
